<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-4">
        {{ $t('messages.passkey.edit_display_name') }}
      </h3>
      <div class="mb-4 px-6">
        <label
          for="displayName"
          class="sr-only"
        >{{ $t('messages.passkey.edit_display_name') }}</label>
        <input
          id="displayName"
          v-model="currentDisplayName"
          type="text"
          class="text-input p-4 text-left h-12 w-full"
        >
      </div>
      <div class="modal-footer hidden sm:flex justify-end">
        <button
          class="mb-4 button-cancel min-w-[120px]"
          @click="close"
        >
          {{ $t("messages.button.cancel") }}
        </button>
        <button
          class="ml-3 mb-4 mr-4 button-primary min-w-[120px]"
          :disabled="!currentDisplayName || !currentDisplayName.trim()"
          @click="save"
        >
          {{ $t('messages.button.ok') }}
        </button>
      </div>
      <div class="modal-footer flex-col sm:hidden p-6">
        <button
          class="button-primary w-full mb-4"
          :disabled="!currentDisplayName || !currentDisplayName.trim()"
          @click="save"
        >
          {{ $t('messages.button.ok') }}
        </button>
        <button
          class="button-cancel w-full mb-6"
          @click="close"
        >
          {{ $t("messages.button.cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  name: 'EditPasskeyDialog',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    passkey: {
      type: Object,
      default: null
    }
  },
  emits: ['save', 'close'],
  setup(props, { emit }) {
    const currentDisplayName = ref('');

    watch(() => props.passkey, (newVal) => {
      if (newVal) {
        currentDisplayName.value = newVal.display_name || '';
      }
    }, { immediate: true });

    const save = () => {
      if (props.passkey && currentDisplayName.value && currentDisplayName.value.trim()) {
        emit('save', {
          ...props.passkey,
          display_name: currentDisplayName.value.trim()
        });
      }
    };

    const close = () => {
      emit('close');
    };

    return {
      currentDisplayName,
      save,
      close,
    };
  },
};
</script>